import React, {useMemo} from "react";
import {Button, Divider, Stack, TextField, Typography} from "@mui/material";
import validator from "validator";

interface SettingsProps {
  email: string;
  onSave: (value: string) => void;
}

export default function Settings({email, onSave}: Readonly<SettingsProps>) {
  const [value, setValue] = React.useState(email);
  const [error, setError] = React.useState(false);
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  }

  useMemo(() => {
    if (validator.isEmail(value)) {
      setError(false)
    } else {
      setError(true)
    }
  }, [value])

  return (<Stack>
    <Typography variant="h5">Settings</Typography>
    <Divider sx={{my: 2}}/>
    <Stack direction="column" spacing={2} sx={{p: 2, width: 300}} alignItems="left">
      <TextField
        label="Reply-to email"
        value={value} onChange={onChange} error={error}
        helperText={error && "Incorrect email address"}/>

      <Button variant="contained" disabled={error} onClick={() => onSave(value)}>Save</Button>
    </Stack>
  </Stack>)
}